module.exports = __webpack_public_path__ + "static/media/lottery_detail_bottom@2x.e101a0d1.webp";